import { token } from '@/token';

// designs-backend sits behind /api: the designs nginx when deployed, Vite's
// proxy in dev. Both drop the prefix and pass the Kinde token through.
export const BASE_URL = '/api';

export class DesignsBackendError extends Error {
  constructor(
    readonly status: number,
    readonly body: unknown,
  ) {
    super(`designs-backend answered ${status}`);
    this.name = 'DesignsBackendError';
  }
}

const readBody = async (res: Response): Promise<unknown> => {
  if (res.status === 204) return undefined;
  const isJson = res.headers.get('content-type')?.includes('application/json');
  return isJson ? res.json() : res.text();
};

// The mutator every generated call goes through (orval.config.ts): adds the
// signed-in person's Kinde access token, and throws DesignsBackendError on
// any non-2xx so callers only ever see the success body.
export const designsBackendFetch = async <T>(
  url: string,
  options: RequestInit,
): Promise<T> => {
  const accessToken = await token.getToken();
  const headers = new Headers(options.headers);
  if (accessToken) headers.set('Authorization', `Bearer ${accessToken}`);

  const res = await fetch(`${BASE_URL}${url}`, { ...options, headers });
  const body = await readBody(res);
  if (!res.ok) throw new DesignsBackendError(res.status, body);
  return body as T;
};
